import React, { useEffect, useState } from 'react';

import Unauthorized from 'screens/Unauthorized/Unauthorized';
import { getCacheVal, isValidToken } from 'services/utils';
import { useError } from 'services/utils';
import { useGetUserSettingsQuery } from '../../services/graphql/main';

type Props = {
  children: JSX.Element;
};

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { addError } = useError();

  const isLoggedIn = isValidToken(getCacheVal('token'));

  const [canAccess, setCanAccess] = useState<boolean>(false);

  const { data, loading } = useGetUserSettingsQuery({ skip: !isLoggedIn, onError: (err) => addError(err, 'error') });

  useEffect(() => {
    if (data) {
      setCanAccess(data.userSettings.osrAccess);
    }
  }, [data]);

  if (!isLoggedIn || !canAccess) {
    return <Unauthorized />;
  }

  return children;
};

export default ProtectedRoute;
